<template>
    <el-dialog
      :title="title"
      :visible.sync="bulkUpdateDialog"
      width="420px">
      <span class="dialog-center">{{content}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">确 定</el-button>
        <el-button @click="bulkUpdateDialog = false">取 消</el-button>
      </span>
    </el-dialog>
</template>
<script>
import {
  customerTemplateUpdate,
  customerTemplateDelete
} from '@/api/customer/customerManage'
export default {
  props: ['title', 'content'],
  data () {
    return {
      bulkUpdateDialog: false, // 批量更新
      type: 1,
      updateList: []
    }
  },
  methods: {
    // 批量更新/解绑初始方法
    onInitial (type, checkList) { // type=1是批量更新,2是批量解绑
      this.updateList = checkList
      this.type = type
      if (checkList.length <= 0) {
        this.$message.error('请选择需要绑定的数据')
        return
      }
      this.bulkUpdateDialog = true
    },
    // 确定
    onConfirm () {
      this.updateList.forEach(item => {
        item.cptId = this.$route.query.id
      })
      if (this.type === 1) { // 批量更新
        customerTemplateUpdate(this.updateList).then(res => {
          if (res.data.code === 200) {
            this.$message.success('批量更新成功!')
            this.bulkUpdateDialog = false
            this.$emit('getOnlineList')
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 2) { // 批量解绑
        const params = []
        this.updateList.forEach(item => {
          params.push(item.id)
        })
        customerTemplateDelete(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('批量解绑成功!')
            this.bulkUpdateDialog = false
            this.$emit('getOnlineList')
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
